export default {
  version: 22,
  objectStores: {
    /*sessions: {
      keyPath: "id",
      resultType: "object"
    },
    signIns_lastSuccess: {
      keyPath: "id",
      resultType: "object"
    },
    signIns_offline: {
      keyPath: "id",
      resultType: "object"
    },
    pending_calls: {
      keyPath: "",
      resultType: "array"
    },*/
    PDV_Productos: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "indexed",
          keyPath: ['Tenant', 'Upat'],
          unique: false
        },
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    RVA_Tarifas: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Clientes: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "indexed",
          keyPath: ['Tenant', 'UpdatedAt'],
          unique: false,
        },
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    GBL_Permisos: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    MBS_Planes: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    MBS_Beneficios: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    MBS_Membresias: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "indexed",
          keyPath: ['Tenant', 'Upat'],
          unique: false
        },
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    MBS_Periodos: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    BNK_LineasCredito: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "indexed",
          keyPath: ['Tenant', 'upat'],
          unique: false
        },
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Inventario: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Productos_Categorias: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Promociones: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    RVA_Catalogo: {
      keyPath: "id",
      resultType: "object",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    RVA_Departamentos: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    Ids_Departamentos: {
      keyPath: "id",
      resultType: "object",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    RVA_Mayoristas_Coleccion: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Inventario_Origenes: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Departamentos: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_TipoCambio: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Monedas_Lista: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Pagos_Tipos: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ]
    },
    PDV_Modificadores: {
      keyPath: "id",
      resultType: "array",
      indexes: [
        {
          name: "indexed",
          keyPath: ['Tenant', 'Upat'],
          unique: false
        },
        {
          name: "Tenant",
          keyPath: 'Tenant',
          unique: false
        }
      ],
    }
  }
}
